import React, { useState } from 'react';
import useAuth from '~/hooks/useAuth';

import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import isBrowser from '~/utils/is-browser';
import ga from '~/utils/ga';

export const useMission1 = (updateAbleMisssionState, isValidAuth, openModal) => {

  const sessionAuthKey = isBrowser() && sessionStorage.getItem('authKey');

  const [ checkMission1Condition, setMission1Condition ] = useState({
    watchedVideo: false,
    checkPersonalInfoType1: false,
    selectedResult: [],
    submitResult: '',
  })
  //유투브를 보았다.
  const watchedYoutube = (e) => {
    if (e.target) {
      return setMission1Condition(prev => ({...prev, watchedVideo: true}));
    }
  }

  //개인정보동의를 클릭했다.
  const clickUserAgreement = (e) => {
    if (!isValidAuth()) {
      return;
    }
    const { name } = e.target
    setMission1Condition(prev => ({...prev, [name]: !prev[name]}))
  }

  //Item을 고른다.
  const onClickItem = (clickedItemCode) => {
    if (!isValidAuth()) {
      return;
    }

    const { selectedResult } = checkMission1Condition;

    if (selectedResult.includes(clickedItemCode)){
      const result = selectedResult.filter(code => code !== clickedItemCode);
      setMission1Condition(prev => ({...prev, selectedResult: result}))

    } else {
      setMission1Condition(prev => ({...prev, selectedResult: [...prev.selectedResult, clickedItemCode]}))
    }
  }

  const isValidateMisson1 = () => {
    const { 
      watchedVideo, 
      checkPersonalInfoType1, 
      selectedResult,   
    } = checkMission1Condition

    if (!isValidAuth()) {
      return false;
    }
    
    if (!watchedVideo) {
      alert('다방 신규 CF를 확인하셔야 미션을 제출할 수 있습니다.')
      return false;
    }

    if (!checkPersonalInfoType1) {
      alert('개인정보 필수 항목에 동의하셔야 이벤트 참여가 가능합니다.')
      return false;
    }

    if (selectedResult.length === 0 ) {
      alert('보기를 선택하셔야 이벤트 참여가 가능합니다.')
      return false;
    }

    return true;
  }

  //미션1 정답 제출한다.
  const submitMission1 = async ableMission1 => {

    //미션2가 제출하기버튼일때
    if (ableMission1 === null) {
      if (isValidateMisson1()) {

        const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL;

        const temp = {
          authKey: sessionAuthKey,
          answers: checkMission1Condition.selectedResult,
        };

        try {
          const { result } = await apiCall.post(`${host}/api/v1/event/2023/dabang/tvc/mission1`, temp);

          updateAbleMisssionState({
            ableMission1: result.mission1Status === true ? true : false,
            mission1Count: result.mission1Count
          })

          setMission1Condition(prev => ({...prev, submitResult:  result?.mission1Status === true  ? 'success' : 'fail' }))
          openModal();
          
          ga('23-03_TVC', '미션 제출하기', '미션1 제출하기');

        } catch(error) {
          const errorMessage = error.message || '네트워크 문제가 생겼습니다.';
          console.log(error)
          alert(errorMessage)
        }
      }

    } else if (ableMission1 === true) {
      //카카오 공유링크
      window.Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: '이벤트 혜택 보면, 다방 할 수밖에!',
          imageUrl: `https://static.dabangapp.com/img/event/tvc_2023/tvc_top.png`,
          link: {
            webUrl: `${window.location.origin}/2023/03/tvcPc/`,
            mobileWebUrl: `${window.location.origin}/2023/03/tvcPc/`,
          },
          description: '다방에서 미션 완료하고, 최대 100만원 상당 월세 지원금과 자취템 받아 가세요.',
        },
        installTalk: true,
      });
      
      const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL;
      
      apiCall.get(`${host}/api/v1/event/2023/dabang/tvc/share`, { authKey: sessionAuthKey });

      //미션2가 내일도전하세요 버튼일때
    } else {
      return;
    }
  }

  return {
    watchedYoutube,
    clickUserAgreement,
    onClickItem,
    submitMission1,
    setMission1Condition,
    checkMission1Condition,
  }
}
